// Generated from the 2026-10-19 person-label review (scratchpad list, never committed). Hashed keys
// (personLabelKey) of group labels reviewed as natural persons; never the names themselves.
export const REVIEWED_PERSON_GROUP_LABEL_KEYS: readonly string[] = [
  '0042f5e9',
  '005e2d2a',
  '006bc211',
  '0079266d',
  '00a74aad',
  '00b78f56',
  '00dbf1b4',
  '00eba9ce',
  '011625d5',
  '01327846',
  '01a0475e',
  '021243cd',
  '021c844f',
  '02cfefb8',
  '02ddeb8e',
  '0347ae53',
  '037fad11',
  '0453cc8d',
  '047910ee',
  '049d3b4d',
  '052d5cda',
  '0651eaa5',
  '06d10ed2',
  '07037e0f',
  '0706350b',
  '071fa3f3',
  '072898d5',
  '07506be9',
  '07a9e8d0',
  '07b5d30e',
  '07e1d337',
  '0825a0d4',
  '08d838f5',
  '09141f9c',
  '0a48113e',
  '0a4930bf',
  '0a4ba691',
  '0b02eaf8',
  '0b1f35e4',
  '0b4f9696',
  '0b842971',
  '0bc756dd',
  '0c13ff10',
  '0c454982',
  '0c533d71',
  '0c7a69f8',
  '0c8e64ca',
  '0ca36666',
  '0cf7c7d4',
  '0cfbdfc5',
  '0d4ad9a3',
  '0d96bf0d',
  '0da9d5be',
  '0de008b7',
  '0e71a6b3',
  '0ee86d9b',
  '0ef17e5a',
  '0fd4822e',
  '1077a295',
  '10798ee7',
  '10910945',
  '10933ddd',
  '10d855b2',
  '11d9ffe5',
  '1209e02f',
  '12279469',
  '124998c2',
  '12b210e4',
  '132de46e',
  '13704bcc',
  '13721ab4',
  '13898443',
  '1398787c',
  '13b57a4a',
  '1431d46b',
  '145684c6',
  '14f3e185',
  '1532f759',
  '157c6715',
  '15ba9017',
  '16111806',
  '1660ce60',
  '173e712c',
  '17b17913',
  '17e53cd7',
  '17eb6787',
  '18466c56',
  '189bfe53',
  '18f743c7',
  '19a5bfed',
  '19c98978',
  '19dfc56b',
  '19f217a7',
  '1a192dfb',
  '1a4cd1ac',
  '1a5f11f3',
  '1a864632',
  '1ab48372',
  '1ad8a519',
  '1afdf6a2',
  '1b6c55f4',
  '1b720051',
  '1bacf07c',
  '1bbd5564',
  '1bfca2f3',
  '1c42f717',
  '1d2a8f11',
  '1d57f359',
  '1de7d98b',
  '1e526031',
  '1fc9e164',
  '1ff3e937',
  '201a82e4',
  '20219068',
  '20a4b854',
  '21382155',
  '213b5e0e',
  '217e3af1',
  '21f76573',
  '226bc111',
  '22a00d8c',
  '22f96914',
  '232913d2',
  '236f074c',
  '237e0644',
  '23cbb3ad',
  '242de395',
  '24ccb708',
  '24f76862',
  '2553eaad',
  '267ea8c7',
  '26d9aced',
  '27a96e5d',
  '27e59749',
  '28d0db44',
  '28ec1f74',
  '2976ffbd',
  '29a75743',
  '2ae00f8f',
  '2ae76b9b',
  '2b74c097',
  '2bdf09e7',
  '2c14ad61',
  '2cd1a838',
  '2cda52a9',
  '2ce162bb',
  '2d24675b',
  '2d5920a3',
  '2dd3c149',
  '2df2af81',
  '2e22f2d6',
  '2e891d0e',
  '2efdd8bd',
  '2f14dffe',
  '2f1ebf07',
  '2f374789',
  '2f7858f4',
  '2f98ed8c',
  '2fb5308f',
  '2fe0cb0a',
  '302ae552',
  '30b12584',
  '30bc5214',
  '313f14e5',
  '314a08df',
  '315596fd',
  '3165d716',
  '318a4c67',
  '321f17f3',
  '325d033a',
  '332e2105',
  '337101e0',
  '3381ae11',
  '3446840d',
  '3446bdce',
  '34d6e4cd',
  '34f01bfa',
  '352169ac',
  '35232dd0',
  '3536b6bc',
  '355f9cbf',
  '35bb7c06',
  '35c05386',
  '35f3595e',
  '3602c0cc',
  '3618418f',
  '361f007e',
  '365816bf',
  '367b86ef',
  '36bff1b3',
  '36dff3c2',
  '371c2825',
  '3730555e',
  '376717d9',
  '379eafcb',
  '37edbe27',
  '389a9618',
  '38bd0a83',
  '392cd843',
  '39bf54f8',
  '3a7440f3',
  '3ab3f80f',
  '3b6f73e5',
  '3bba5983',
  '3bc9726f',
  '3c16a326',
  '3cc25161',
  '3cced918',
  '3d2c23e9',
  '3d37df3f',
  '3d4ef75b',
  '3d7ea476',
  '3d85436f',
  '3d98dd67',
  '3d992fd1',
  '3dd17094',
  '3efc825d',
  '3f0bcc74',
  '3f2ba094',
  '3f334cd4',
  '3fa7e2d9',
  '3fcc7be7',
  '40454858',
  '40729d72',
  '40c2b76e',
  '40f2720b',
  '41977f02',
  '419f4c2e',
  '41a47ba3',
  '422eb4b2',
  '4240f14f',
  '424d4406',
  '425d2a99',
  '427f8d38',
  '4291ed40',
  '42e432ae',
  '42ecf116',
  '42f0cd36',
  '430ee754',
  '43902a8f',
  '439c53d3',
  '43d4b835',
  '43ed47db',
  '440634ba',
  '443fd126',
  '44a80530',
  '44eacd51',
  '455021cb',
  '4570275b',
  '45e62b1a',
  '45f0aab5',
  '4605929a',
  '46067109',
  '46750e3f',
  '47060729',
  '473f7ae7',
  '4773141a',
  '47a4b65f',
  '47bda2bc',
  '482070db',
  '486a3399',
  '4a1b59ce',
  '4a2a8d22',
  '4a70cf93',
  '4a78272b',
  '4a7de8c4',
  '4b0aa1d7',
  '4b52dc2c',
  '4b6a934d',
  '4bb53a81',
  '4bc8d732',
  '4cd0599d',
  '4d951173',
  '4d9abe57',
  '4daa64d2',
  '4e6b0ba5',
  '4eab9ecb',
  '4ec130fc',
  '4eff55e0',
  '4fa302d5',
  '4ff9ab9b',
  '50083007',
  '500fd8fd',
  '502e7bac',
  '50b5036e',
  '50d3d3d0',
  '512f4c4f',
  '5154a22f',
  '51756f8e',
  '5186c649',
  '5235dc8c',
  '526f594f',
  '528f2ce6',
  '52d3467b',
  '531924ae',
  '531c9e69',
  '531f0232',
  '532bb099',
  '5368a7e2',
  '53afcaf0',
  '53f4b40e',
  '544f3670',
  '547232ee',
  '5529db4c',
  '55603839',
  '5580132a',
  '5582dc50',
  '55a27df5',
  '568be921',
  '5699959c',
  '569e364a',
  '56ae25d9',
  '56bfaba2',
  '56dcd449',
  '571dc931',
  '5725dc2c',
  '57296d55',
  '57a40d54',
  '57c42777',
  '57d6abc7',
  '57d99031',
  '57f0d6bb',
  '58287cad',
  '583294fe',
  '586d5531',
  '59021fce',
  '5903e713',
  '59564d83',
  '5992948b',
  '5a02eeb7',
  '5a032a67',
  '5a4699d2',
  '5a4b12c3',
  '5af0197e',
  '5b59b365',
  '5bc97220',
  '5bf6efd0',
  '5c313183',
  '5cc33749',
  '5d8d728c',
  '5df739be',
  '5e1434f0',
  '5e63d923',
  '5fd62a67',
  '6015fb7d',
  '605289ac',
  '610a1e41',
  '6138c964',
  '614557b2',
  '61a92148',
  '61d5db9f',
  '620a1158',
  '62110a6e',
  '62def82c',
  '63336fa4',
  '634f17eb',
  '6354d384',
  '63d825f3',
  '640f04eb',
  '6480ea9d',
  '64b11760',
  '64c51f5a',
  '656d25a2',
  '65d66bee',
  '666adc0f',
  '669b1a82',
  '67039c2f',
  '67727a55',
  '67a617a0',
  '67d2fa08',
  '68855d91',
  '68f8a0bd',
  '68faec06',
  '69215ca8',
  '695ff812',
  '698d70bb',
  '69a75836',
  '69b22982',
  '69e7eff3',
  '6a4ebb6d',
  '6a65e471',
  '6af86e7e',
  '6b3622b5',
  '6b700507',
  '6b948650',
  '6bd1444e',
  '6bdeb5b1',
  '6be3858f',
  '6c269697',
  '6c7f5218',
  '6cf6f7c2',
  '6cfd88cc',
  '6d0ab301',
  '6dc175e3',
  '6ddc12b0',
  '6de1b442',
  '6e96c1e7',
  '6edb11c1',
  '6ef76854',
  '6fe7fcba',
  '6ffc18bf',
  '7068b50e',
  '70acbe34',
  '70bce45f',
  '70c23f8d',
  '718b1551',
  '71941b6d',
  '71a404eb',
  '71f130e7',
  '7234571d',
  '72b8e40c',
  '72da63ae',
  '72fae233',
  '7312ff22',
  '733ff188',
  '73d29e25',
  '74309246',
  '7450bf25',
  '747cd222',
  '7487093d',
  '75b815e4',
  '75c03b4f',
  '75ce4e18',
  '7621c9e4',
  '762c1061',
  '76512832',
  '7686ade6',
  '7693ff38',
  '76d51462',
  '771b7e55',
  '781302ff',
  '78311348',
  '78445543',
  '7996f397',
  '79c6e5b1',
  '79d87bf0',
  '79da0ca9',
  '7a06dfcb',
  '7a3a07ec',
  '7a848894',
  '7af4881f',
  '7b68ff48',
  '7b705aa9',
  '7b949245',
  '7bb4be75',
  '7bb930e0',
  '7bc5e973',
  '7bf115d2',
  '7c49d21f',
  '7c5a783f',
  '7c7050a4',
  '7cdaea6a',
  '7d235de3',
  '7d72faca',
  '7e0fa57b',
  '7e252d77',
  '7ed2ddca',
  '7f486879',
  '7f6c5f51',
  '7f89aab1',
  '7fa1efad',
  '801689f5',
  '80872937',
  '80940839',
  '80982d2e',
  '810f0633',
  '819b5575',
  '824c4c41',
  '8280efce',
  '8284e0cd',
  '82a8409e',
  '82e91fb4',
  '8375c61c',
  '839d4835',
  '83d02b4f',
  '84073f88',
  '84133d87',
  '841f565c',
  '84763f7b',
  '8483de8f',
  '853490e3',
  '8557deaf',
  '856748f2',
  '8628b3d5',
  '870acad5',
  '8743202d',
  '878fd779',
  '87cfb2f0',
  '87d5e47d',
  '87d70f81',
  '87e26b34',
  '881f77ed',
  '88b60400',
  '88c13d41',
  '88d61eca',
  '89b0a5c8',
  '89b95807',
  '8a0052a0',
  '8b0e1cde',
  '8b319eac',
  '8b35fd71',
  '8b3aab53',
  '8bafd5f2',
  '8be61e19',
  '8c3ea6b9',
  '8c724dd7',
  '8c76d66e',
  '8cd0d8f9',
  '8ce607fc',
  '8d14825c',
  '8d300eec',
  '8d3dee55',
  '8d5ff7c2',
  '8dabfb2e',
  '8db174c6',
  '8dcc2216',
  '8ddfb75a',
  '8e7e62a1',
  '8e9f9805',
  '8ec63725',
  '8eff1158',
  '907ef781',
  '91046b95',
  '91091ef7',
  '9125d1e3',
  '918f8766',
  '91c59729',
  '92075e2f',
  '92323162',
  '9266f736',
  '932f035b',
  '933c055a',
  '93622014',
  '938fc842',
  '93a2ce89',
  '93d89f32',
  '93ece528',
  '94134890',
  '94da3681',
  '94e1a5ff',
  '94f650e9',
  '954a728f',
  '95526576',
  '95901059',
  '9600af20',
  '960c4a5a',
  '968abfaa',
  '969016b6',
  '969a3bf9',
  '96dc6324',
  '96ecbcd1',
  '97131e1c',
  '972d2189',
  '97ac5f2f',
  '9802f55b',
  '98d5aa5a',
  '994651a4',
  '994b9ba1',
  '9a1e4f87',
  '9a6a8f1b',
  '9a7e4a3b',
  '9a9243c3',
  '9abf6093',
  '9b0f3688',
  '9b45f1f1',
  '9ba25b47',
  '9bb14624',
  '9be152e0',
  '9c2d2b42',
  '9d71c331',
  '9ddc738e',
  '9e097414',
  '9e850924',
  '9ec643eb',
  '9ec9a357',
  '9ee2ea49',
  '9eee36c2',
  '9ef30d1c',
  '9f33ba56',
  '9f5006f5',
  '9f8223db',
  'a009cc97',
  'a009dc32',
  'a086b95b',
  'a1749f4a',
  'a228e4d1',
  'a31e1710',
  'a3645df9',
  'a369af57',
  'a3f86e12',
  'a414bc56',
  'a54d32d9',
  'a58e91d4',
  'a5bfbeee',
  'a648beab',
  'a657ed05',
  'a6ad28a3',
  'a6d5e426',
  'a7731143',
  'a793af93',
  'a89565ef',
  'a8e029ea',
  'a9257b33',
  'a94c0415',
  'aa164d20',
  'aa5bfe48',
  'ab030abb',
  'ab3b45c6',
  'ab4c5611',
  'ab7a22ac',
  'abfcde4f',
  'ac252d1b',
  'ac4904f9',
  'ac4df12d',
  'aca15628',
  'ad1cd84a',
  'ad5cef62',
  'ad82cdc2',
  'ad96c307',
  'adfa12f1',
  'adfedc3b',
  'ae02b63f',
  'ae11496f',
  'ae862aa7',
  'aed3a942',
  'af2f670b',
  'afcfc9df',
  'b030dae3',
  'b0384ac1',
  'b0495295',
  'b0500fff',
  'b0ba9243',
  'b0f87392',
  'b0ff5e80',
  'b105710f',
  'b138a219',
  'b185b841',
  'b199daac',
  'b2278868',
  'b28e9a86',
  'b30a554d',
  'b36a851d',
  'b3d1f863',
  'b49e621a',
  'b4f5961b',
  'b5502377',
  'b57617c1',
  'b5a4c3ba',
  'b5de5ac9',
  'b6123802',
  'b6ca79f8',
  'b6d4f782',
  'b6f5b77b',
  'b74637c6',
  'b77521d4',
  'b8134c6b',
  'b869f7e1',
  'b8702dba',
  'b88a961e',
  'b8b96e76',
  'b8f7236e',
  'b95be297',
  'b9fbe8b7',
  'b9ff7d53',
  'ba09876d',
  'ba784691',
  'bac3b5fe',
  'bbea98bf',
  'bbfdae9c',
  'bc19e3ff',
  'bc3779a5',
  'bc414a4a',
  'bc551f42',
  'bc5d3ad7',
  'bca0fc15',
  'bd37ea2c',
  'bd3d53f0',
  'bd9f7d5f',
  'bdb4f233',
  'be2a0145',
  'bf2f56a0',
  'bf58a6aa',
  'bfde18c0',
  'bfe2aab8',
  'c076c089',
  'c206bee2',
  'c2099764',
  'c21aaf5d',
  'c23b2401',
  'c2dbb68c',
  'c34b5e84',
  'c35b6e60',
  'c396957e',
  'c3aa585b',
  'c3c984b5',
  'c3d2241d',
  'c3fee87c',
  'c4080303',
  'c444d405',
  'c47797a0',
  'c5521c09',
  'c59cd069',
  'c5d0a527',
  'c6d5c077',
  'c759677b',
  'c7961238',
  'c7bc6efa',
  'c82a94ea',
  'c84bc9a8',
  'c8c8ea2b',
  'c8ce5567',
  'c8efabcf',
  'c9d0b375',
  'ca5f4cc0',
  'caab4851',
  'cab74b29',
  'cad73f80',
  'cb3bf6eb',
  'cb95b680',
  'cb9c3e97',
  'cc396f83',
  'cc662214',
  'cc6b9f04',
  'cc8da551',
  'ccb8adde',
  'ccc7e87c',
  'cce7759d',
  'ccef115f',
  'cd162acf',
  'cd2fe6f2',
  'cd44cc01',
  'cd5df1af',
  'cdb088af',
  'ceb024e5',
  'cf1de6a2',
  'cf2ea638',
  'cf7da3f2',
  'cf98e75f',
  'cffd36e6',
  'd029a988',
  'd05ee64d',
  'd09d28ab',
  'd0a11b73',
  'd0e9b8f6',
  'd11e1715',
  'd16534b3',
  'd19bfeca',
  'd1c4af5c',
  'd1c848bb',
  'd286640c',
  'd2a3cdf0',
  'd2af7946',
  'd41c5198',
  'd44f0865',
  'd48eacc3',
  'd49bc5ed',
  'd4e776c4',
  'd4f770ad',
  'd554569e',
  'd5a6b034',
  'd5a7a2bf',
  'd5ec3604',
  'd6192eb0',
  'd625e474',
  'd627675e',
  'd7bbaca4',
  'd80d81fb',
  'd851c146',
  'd854c3c8',
  'd8a96a15',
  'd8c6c5af',
  'd8c72734',
  'd8f69e38',
  'd9a7f545',
  'd9cd9f2f',
  'd9f5c9b6',
  'da3084ed',
  'da342a2c',
  'dab957bc',
  'db0ffa49',
  'db47ea88',
  'dbb7cad9',
  'dc28bd7d',
  'dce24faf',
  'dd4be761',
  'dd5955a2',
  'de274321',
  'de550279',
  'de5f46cb',
  'deaa350c',
  'dede8bae',
  'df0a0ba7',
  'df177430',
  'e00d8365',
  'e0422123',
  'e1ccd620',
  'e1dd6d2f',
  'e2060733',
  'e21e1445',
  'e28993cd',
  'e325a98e',
  'e366e4cb',
  'e368c3f3',
  'e3a3ddc1',
  'e3ca7995',
  'e4249dc9',
  'e429037f',
  'e42e3553',
  'e438790f',
  'e4735cdb',
  'e4cbe5d5',
  'e4fd26ce',
  'e55480a1',
  'e56b7255',
  'e59f87c7',
  'e5a74a3e',
  'e5abd6cc',
  'e5b69f75',
  'e5c9ce30',
  'e6867dfe',
  'e6bd6d17',
  'e6c48161',
  'e6eae164',
  'e7749a5f',
  'e77c7a90',
  'e828a7e4',
  'e8441b55',
  'e857927d',
  'e8d9eadd',
  'e9593476',
  'e978fb48',
  'e99b8e02',
  'e9d802c7',
  'e9de131a',
  'e9de19ee',
  'ea5561d8',
  'ea83ed66',
  'ea887b65',
  'ead10196',
  'eb159c57',
  'eb3b3170',
  'eb581a8b',
  'eb808069',
  'ec14b29e',
  'ecbf1c7c',
  'eccb570e',
  'ecdf2918',
  'ed334148',
  'ed398e21',
  'ed64585c',
  'ed74a12a',
  'ed980886',
  'ed9eb9e8',
  'edbdf840',
  'eea3c036',
  'ef170a06',
  'ef319f46',
  'ef5a479d',
  'ef9b67a3',
  'efbf6067',
  'efc81eee',
  'efd3a12d',
  'f0110e23',
  'f04fe33c',
  'f080c37d',
  'f0f25c3c',
  'f1011edc',
  'f147bc18',
  'f152305b',
  'f197b6ec',
  'f1abe75a',
  'f21ae40e',
  'f2896bba',
  'f305fea4',
  'f378f7b3',
  'f3c661ff',
  'f3dea1cb',
  'f4135971',
  'f434898f',
  'f5392261',
  'f542a668',
  'f5f639b2',
  'f65407a6',
  'f686d688',
  'f6d9cd1d',
  'f75bc99c',
  'f789b8d5',
  'f7e95d98',
  'f7f720d3',
  'f7f8020f',
  'f82f66a2',
  'f84001c8',
  'f894252c',
  'f89539b6',
  'f8b3bc57',
  'f8c36089',
  'f90a9ddd',
  'f91a627c',
  'faa637fc',
  'fab2f8e9',
  'fab4ca32',
  'fae850d7',
  'fb010547',
  'fb66bb8e',
  'fb6f2514',
  'fb7b3e01',
  'fb7d2670',
  'fb881bdc',
  'fba092b2',
  'fbef0de9',
  'fc123af5',
  'fc289a69',
  'fc2c8699',
  'fd0c6f92',
  'fd8cf1e0',
  'fdb7c4cf',
  'fdbabd28',
  'fdd7f7cd',
  'fe067cd5',
  'fe669260',
  'feb30a1b',
  'ffb6644e',
  'ffb7673a',
];

// Labels the same review read and judged NOT a person (companies, brands, public bodies); the audit
// script skips them so a reviewed decision is not re-asked.
export const REVIEWED_NOT_PERSON_GROUP_LABEL_KEYS: readonly string[] = [
  '0034974e',
  '004943ca',
  '0083ae9e',
  '00cf2e6e',
  '019ac20c',
  '01ce538c',
  '026f8ae6',
  '02a8715c',
  '048d11a0',
  '04c989d8',
  '04d89ac7',
  '04e216b3',
  '04f3641d',
  '0553d50d',
  '05a7f877',
  '06c3262c',
  '06e28f7e',
  '07fa7e74',
  '0824b1f9',
  '09763097',
  '0a1aa394',
  '0a308e54',
  '0a8fafe4',
  '0ac88055',
  '0ad60b25',
  '0aec9dbb',
  '0aef6144',
  '0bc71395',
  '0cd94bdc',
  '0cfec6cb',
  '0e470cab',
  '0e4c4f6b',
  '0fc64fd0',
  '102d1189',
  '105314d5',
  '11af3ee3',
  '11cdbb1e',
  '11fd9dd9',
  '1216b78b',
  '1225cde0',
  '126854c8',
  '12b7beac',
  '14c27a26',
  '1557fc32',
  '15647626',
  '15829279',
  '179d3c5a',
  '188f2746',
  '18f79c9e',
  '1a5f6285',
  '1a69a6e7',
  '1b1a2db1',
  '1befc636',
  '1c2928ac',
  '1cdf73be',
  '1e5ad959',
  '1e883f8a',
  '1e8893e3',
  '1ed57111',
  '1f618b80',
  '1f6342d2',
  '1fdeaa4e',
  '202e6f7e',
  '2101a433',
  '223c74cd',
  '23070718',
  '24642d9f',
  '2477c636',
  '24e85639',
  '24f0b383',
  '2627ce9c',
  '265b48e7',
  '26ad843f',
  '272698f6',
  '272ac194',
  '272e84d4',
  '28d40c93',
  '28d54718',
  '2956d728',
  '2969d66f',
  '297e540b',
  '2a80fda1',
  '2ac68b5d',
  '2b0c6492',
  '2b2f6ef5',
  '2cce06c5',
  '2d0ee814',
  '2d717ec4',
  '2e0b6ff6',
  '2e522a27',
  '2e9df4c5',
  '2fcb01a1',
  '2fdfa0c4',
  '30896e51',
  '30a072ce',
  '3180f769',
  '31d54b28',
  '324a0a2f',
  '32d31080',
  '335c0219',
  '35b62374',
  '361485b2',
  '36b4b9e6',
  '36f2298c',
  '36f4be89',
  '37562921',
  '3783a6ed',
  '3789f4ca',
  '38003478',
  '381d070f',
  '3863f8b0',
  '393e8f70',
  '39989631',
  '3a1fe0e9',
  '3a32b688',
  '3a706b3c',
  '3b110538',
  '3bfd6b1d',
  '3c3bfbd4',
  '3d0412df',
  '3d6e7e7e',
  '3d7ac9d5',
  '3d97b8f6',
  '3e0a628e',
  '3e7ef748',
  '3ef9f2c6',
  '3f0c1426',
  '3f4a7fcc',
  '419432c2',
  '41fb8f7d',
  '4286b10b',
  '42cc5e6d',
  '431db646',
  '43d9b67f',
  '44274f4e',
  '45139b7d',
  '455357dd',
  '455c1a00',
  '458255ec',
  '45e7609f',
  '463128cc',
  '465e83c3',
  '468582da',
  '46e71abd',
  '47025bde',
  '47064bcc',
  '480b5fc0',
  '48288e26',
  '484704a8',
  '48999f9a',
  '48d7cd9e',
  '4911b9e8',
  '4912da6d',
  '49887613',
  '4a632381',
  '4b348c68',
  '4bda39ce',
  '4befd1c5',
  '4bf46fc0',
  '4bf80b25',
  '4c552c55',
  '4c94f0a6',
  '4e12fe21',
  '4e7859c6',
  '4e999a9e',
  '4f29df82',
  '4fcc7167',
  '4ffb32e4',
  '50914c99',
  '50a5dc27',
  '51eb56c8',
  '52c40cef',
  '530260a8',
  '54bd7e41',
  '556aa664',
  '564613ab',
  '564a9379',
  '56d0589c',
  '56f17e46',
  '57c46775',
  '57c4a65e',
  '590e0934',
  '59862fb2',
  '5a13a206',
  '5a7dd357',
  '5ae9c949',
  '5d6020a4',
  '5d7d0a97',
  '5de343ea',
  '5e02245c',
  '5f00ad7e',
  '5f1ade9d',
  '5facc0b0',
  '5fb8eebe',
  '60b835a6',
  '60bd83d6',
  '610b6123',
  '619ae9b9',
  '623c2682',
  '6260e7ad',
  '62bb2c20',
  '633c6478',
  '63b7b791',
  '63badf39',
  '63c30001',
  '64b3f5e9',
  '64bb0586',
  '64ddcb5b',
  '65b9d8dd',
  '65f19f93',
  '662a4d8c',
  '6630c414',
  '66b921d9',
  '66ea6e6e',
  '675781ee',
  '69168ed1',
  '698e8118',
  '6a120084',
  '6a132f95',
  '6afdc36e',
  '6b45d3b2',
  '6b5eb6a8',
  '6be7e04b',
  '6c194d7b',
  '6c8963e3',
  '6c8a3aae',
  '6ce91a9d',
  '6d02aa41',
  '6f3d5547',
  '6fd3b02b',
  '7034b332',
  '70d0e04e',
  '7163ad56',
  '71f6a442',
  '72befba4',
  '7392bce8',
  '73d74242',
  '74106617',
  '74249cdc',
  '7511cea2',
  '75b9f90e',
  '75f3108d',
  '760139b7',
  '76096570',
  '76510a95',
  '76ac504b',
  '7765870f',
  '776b40ff',
  '77fb4d99',
  '78da8ba1',
  '7905112e',
  '79620e83',
  '796428bc',
  '7984257d',
  '799c1bde',
  '7a68fb31',
  '7a8a9a8a',
  '7a95fd27',
  '7afb23b7',
  '7b687918',
  '7c937d0c',
  '7d1f7b60',
  '7d4c0d06',
  '7d5a6180',
  '7d9e5fd3',
  '7e9307da',
  '7f7b8d4d',
  '7f88f009',
  '7fc2aa53',
  '8029fef0',
  '803e352f',
  '8081e4d4',
  '82b3ec4e',
  '82ce009c',
  '82ddaaa9',
  '8318246c',
  '832088b9',
  '8331e433',
  '83412fb3',
  '83598eca',
  '83d8e063',
  '8468925c',
  '849a50ec',
  '84ec1a50',
  '8566cca7',
  '86c20a60',
  '875d5398',
  '880d9db6',
  '89009d1e',
  '89128088',
  '891edea0',
  '8a7c3714',
  '8b3796b9',
  '8d969977',
  '8d9a8696',
  '8dba4d58',
  '8f12ded2',
  '8fe76b61',
  '90450a8e',
  '9074e924',
  '90ebd0ed',
  '91826029',
  '9184e789',
  '91d7346e',
  '92709d93',
  '92cf52be',
  '94264596',
  '947b2e01',
  '948535ab',
  '94ea76ff',
  '962d3f09',
  '9670914a',
  '9671d490',
  '9683f8a5',
  '96b6bbf0',
  '96bef3db',
  '96ca0cf4',
  '981336b3',
  '99279790',
  '9938cf10',
  '99869016',
  '99ac2ecf',
  '9a3320cb',
  '9a44b114',
  '9acb12af',
  '9ad92cba',
  '9b39112c',
  '9c5240bb',
  '9cb1284b',
  '9d50e22b',
  '9e19f7d9',
  '9e7bbcc0',
  '9efc8276',
  '9f0d7df0',
  'a06f6f75',
  'a084f888',
  'a0a21138',
  'a0dfaf68',
  'a0faa323',
  'a14d69bc',
  'a15d4179',
  'a2f5675d',
  'a3275e30',
  'a35523d2',
  'a36517b0',
  'a3682c2f',
  'a3e7bf3c',
  'a41cc23f',
  'a48abbc1',
  'a4ddbb76',
  'a5a921b8',
  'a6b23c57',
  'a72ca8b7',
  'a77288b1',
  'a7878a8e',
  'a94b7eb7',
  'a950065a',
  'a9c33c3e',
  'a9ec12a6',
  'aa420d0d',
  'ac19f377',
  'ac666434',
  'ac89ee2a',
  'ac9e6093',
  'acf6b06e',
  'add4ed62',
  'ae05a1dc',
  'afc1a84e',
  'b01718fa',
  'b04e090e',
  'b0eb1b4f',
  'b0f94ed8',
  'b1686c49',
  'b181b535',
  'b1898008',
  'b1bcd231',
  'b1d3c2b0',
  'b2a3db2f',
  'b2a684ff',
  'b3a3a8e4',
  'b56d85aa',
  'b6729ce5',
  'b6d88804',
  'b7271607',
  'b7a55d0b',
  'b7f43222',
  'b86f0eee',
  'b98b6f23',
  'b995ff2f',
  'ba0805c2',
  'bb494086',
  'bc3c2a3a',
  'bc898c3e',
  'bce88b3b',
  'bcfb69f7',
  'bd37d89f',
  'bdb64b6d',
  'bed845bc',
  'bfd5b027',
  'bfded9db',
  'c0e39bc3',
  'c16c807d',
  'c2ca2f3e',
  'c345c2ec',
  'c44cb69a',
  'c4d34f48',
  'c5162787',
  'c51f8a52',
  'c5f3606d',
  'c61a0f56',
  'c6c16b3b',
  'c74207fc',
  'c7885593',
  'c78a8bcc',
  'c7a3b584',
  'c7cd4724',
  'c7eb49b1',
  'c7ecdc85',
  'c810b6dc',
  'c860079b',
  'c8db5f40',
  'c95ddad3',
  'ca9fd127',
  'cb33bd56',
  'cc481131',
  'cc57dacd',
  'ccc18c61',
  'cce67bbb',
  'cd17c3ec',
  'ce30228b',
  'ce77878a',
  'ce901874',
  'cf4aec09',
  'cf729056',
  'cfbd9bb0',
  'cfca349e',
  'd0417ba9',
  'd139a008',
  'd155a6eb',
  'd1dd1112',
  'd1e08fca',
  'd2c3c652',
  'd2c52062',
  'd2e61892',
  'd32ade67',
  'd3602485',
  'd3ac4f38',
  'd430520b',
  'd46d4e70',
  'd4b78230',
  'd4ec0c30',
  'd52a37c4',
  'd52a96df',
  'd5455156',
  'd57eeaba',
  'd5c9b0c4',
  'd61ea81e',
  'd64aecf6',
  'd6b0d115',
  'd79ed2b6',
  'd7fb5b7e',
  'd841ca19',
  'd8835dcd',
  'd924cfa7',
  'd974c38a',
  'd9942697',
  'da0255c7',
  'da09867d',
  'da6165b7',
  'da8b42bf',
  'db6717ed',
  'db70c918',
  'dc63c69e',
  'dd2250ce',
  'dd5ddc48',
  'dd6872f4',
  'dd8dd632',
  'dd95bd9b',
  'dda32d52',
  'de9e62d4',
  'def1da39',
  'df803677',
  'dfa3a981',
  'dfa8264f',
  'dfb3c43e',
  'e090e69a',
  'e0bfca65',
  'e0ce7919',
  'e0e4fdb3',
  'e2624ccb',
  'e2691369',
  'e26cea59',
  'e28939bb',
  'e291e314',
  'e2cf0c0b',
  'e2ff19a5',
  'e314d488',
  'e37ff9ca',
  'e47d6409',
  'e47f69b8',
  'e4b548a7',
  'e4ca641d',
  'e4e6cdb9',
  'e564208d',
  'e766c9f5',
  'e76cd5b3',
  'e7aed444',
  'e81a419b',
  'e893ac47',
  'e9049461',
  'e90e46b7',
  'e921f46e',
  'e95cf950',
  'e9aae879',
  'ea8367aa',
  'eb093e12',
  'eb613970',
  'ebe155c3',
  'ec33d3f3',
  'ec5de35f',
  'eccc6515',
  'eccee0ef',
  'ecdbf5ed',
  'ee49722c',
  'ef1c098a',
  'ef677038',
  'f015de7a',
  'f041ada2',
  'f09e4498',
  'f105cda3',
  'f1215768',
  'f27034f8',
  'f2bf047a',
  'f2ca12a0',
  'f3936309',
  'f3a288ff',
  'f3a50414',
  'f3a8f389',
  'f3b4314e',
  'f3d1762c',
  'f416b665',
  'f4b5bbe9',
  'f4be4bbc',
  'f4c20b2a',
  'f5e7e4cc',
  'f5f657cf',
  'f6d2f92b',
  'f75a1dbc',
  'f76703ee',
  'f7b8b1af',
  'fa10f383',
  'fa6341b4',
  'faa97c1c',
  'fb3dddaa',
  'fb58e766',
  'fc45a952',
  'fe541cad',
  'ff6b3083',
  'ff77ad56',
];

// Readable names for the private-owner groups that contain a care home (2026-10-20, Alex: yes). Keyed by
// personLabelKey(old person label); the name is the group's largest member company (care-home operators
// first) whose own name does not carry the owner's name, legal-form suffix dropped. Groups whose every member
// is named after its owner stay 'Private-owner group <hash>'. Company names only — never a person.
export const READABLE_PRIVATE_OWNER_GROUP_LABELS: Readonly<Record<string, string>> = {
  '0079266d': 'GB: OLIVER COURT group',
  '07506be9': 'SK: Harmónia života group',
  '08d838f5': 'GR: ΕΥΠΡΑΞΙΑ group',
  '0a48113e': 'EE: OÜ Iira Hooldekodu group',
  '0ef17e5a': 'SK: Seniorvital group',
  '10910945': 'SK: Čas pomoci group',
  '13898443': 'GB: TRALEE group',
  '2d24675b': 'SK: Domov dôchodcov Malý Dunaj group',
  '2dd3c149': 'EE: Sihtasutus Pärnu Haigla group',
  '2efdd8bd': 'GB: WAYSIDE CARE group',
  '355f9cbf': 'GB: MAJORSPAN group',
  '3cced918': 'SK: Domov pre seniorov Golden Age group',
  '455021cb': 'LV: Senior Group Latvia group',
  '4d951173': 'EE: Benita Kodu group',
  '5154a22f': 'GB: WOODHOUSE CARE HOMES group',
  '52d3467b': 'GB: D & L CARE HOMES group',
  '56bfaba2': 'SK: Lienka Pomáha group',
  '5cc33749': 'EE: OÜ Indsalu group',
  '6354d384': 'GB: LOTUS CARE group',
  '69e7eff3': 'SK: ADM group',
  '6af86e7e': 'SK: Humanus group',
  '6be3858f': 'SK: DOM Božieho milosrdenstva group',
  '78311348': 'GR: ΛΕΩΝΙΑ ΘΕΣΣΑΛΟΝΙΚΗ group',
  '7c49d21f': 'GR: IASIS Care group',
  '84073f88': 'EE: Mittetulundusühing VIRUMAA TUGITEENUSED group',
  '853490e3': 'SK: Združenie GERION group',
  '87cfb2f0': 'SK: SENIOR group',
  '8cd0d8f9': 'SK: MEDIK - M group',
  '94da3681': 'GR: ΟΜΟΡΦΗ ΙΡΙΔΑ group',
  '95901059': 'RO: CASA SFANTUL ANDREI group',
  '9e850924': 'GR: ΜΑΘΗΣΗ ΚΑΙ ΘΑΛΠΗ ΡΑΦΗΝΑΣ group',
  a657ed05: 'SK: TOLERANCIA22 group',
  a793af93: 'GB: MANOR LIFE group',
  ac252d1b: 'SK: DOSS - Dom sociálnych služieb group',
  ac4904f9: 'SK: LUX group',
  b8f7236e: 'SK: Humanitarian group',
  c59cd069: 'GB: HARBORNE LANE SPECIALIST CARE CENTRE group',
  c7bc6efa: 'GR: ΚΛΩΘΩ CARE group',
  da3084ed: 'SK: Zariadenie sociálnych služieb Slnečný dom group',
  da342a2c: 'RO: 4GENERAŢII CARE HOME group',
  e368c3f3: 'GR: ΗΡΑΚΛΕΙΟΣ group',
  e4cbe5d5: 'SK: Služby pre seniorov group',
  e5b69f75: 'SK: JUSTÍNA group',
  e6bd6d17: 'EE: Imastu Hooldekodu group',
  f378f7b3: 'SK: Nemocnica s poliklinikou Kráľovský Chlmec group',
  f6d9cd1d: 'EE: AS Vändra Õenduskodu group',
};
